module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOCAYAAAASVl2WAAAAAXNSR0IArs4c6QAAAHtJREFUKFNjnDlz5gUGBoZHX79+DS8qKvrOgAYYZ86c+R8qtoeBgcE/PT39G7IaZAUg8f0MDAw+yIrQFTD8////8N+/f72ys7O/gHRgKIAaf+Tnz5/eeXl5n3ApAKk7zsDA4IlPAUjREYoU4LUCtyMJeRNvQOEMaryRBQBVXWLfjIXMNQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/productDetail/top-bar-icon.png
// module id = 6ljV
// module chunks = 1